import { render, staticRenderFns } from "./PresentationRegistration.vue?vue&type=template&id=2c4c8858&scoped=true&"
import script from "./PresentationRegistration.vue?vue&type=script&lang=js&"
export * from "./PresentationRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PresentationRegistration.vue?vue&type=style&index=0&id=2c4c8858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c8858",
  null
  
)

export default component.exports